<template>
    <div class="users mx-3 pb-2">
        <template v-if="users && users.length > 0">
            <div v-for="user in users" :key="user.id" class="user pointer d-flex align-center justify-space-between">
                <div class="d-flex align-center">
                    <div class="mr-2">
                        <span class="fs--13">{{ Number(user.id) + 1 }}.</span>
                    </div>
                    <v-avatar size="28">
                        <img :src="user.profilePic" alt="User" @error="getDefaultImage">
                    </v-avatar>
                    <span class="fs--14 fw--500" :class="'ml-2'">{{ user.user }}</span>
                </div>
                <div class="bits-info">
                    <div class="d-flex align-center justify-center">
                        <img :src="getIcon(user.value)" width="15" class="mr-2" alt="Bits" />
                        <span class="fs--13 fw--600">{{ user.value.toLocaleString() }}</span>
                    </div>
                </div>
            </div>
        </template>
        <template v-if="(!users || users.length < 1) && (!top || top.length < 1)">
            <div class="text-center">
                <span class="reward-text fs--13 fw--600">No user found.</span>
            </div>
        </template>
    </div>
</template>

<script>
import { getBitIcon } from '@/utils/utils';
export default {
    name: 'UserList',
    props: {
        users: Array,
        top: Array
    },
    setup() {
        const getIcon = (value) => {
            return getBitIcon(value);
        }

        const getDefaultImage = (e) => {
            e.target.src = 'https://static-cdn.jtvnw.net/user-default-pictures-uv/41780b5a-def8-11e9-94d9-784f43822e80-profile_image-300x300.png'
        }

        return { getIcon, getDefaultImage }
    }
}
</script>